(
    function (skyward, $)
    {
        skyward.stateassignedalternativeid = skyward.stateassignedalternativeid || {};

        skyward.stateassignedalternativeid.getnewstateassignedalternativeid = function () {
            var parentFieldset = skyward.stateassignedalternativeid.getnewstateassignedalternativeid.caller.arguments[0].target.closest(".fieldWrapper");
            var parentDiv = skyward.stateassignedalternativeid.getnewstateassignedalternativeid.caller.arguments[0].target.closest("div");
            var button = $(this);
            button.off();
            $.when(skyward.stateassignedalternativeid.generatestateassignedalternativeid(parentFieldset, parentDiv)).then(function () {
                button.on("click", skyward.stateassignedalternativeid.getnewstateassignedalternativeid);
            });
        };

        skyward.stateassignedalternativeid.generatestateassignedalternativeid = function (parentFieldset, parentDiv) {
            var inputField = $(parentFieldset).find('input.AssignStateAlternativeID');
            var helpLabel = $(parentFieldset).find('label.help');
            var titleLabel = $(parentFieldset).find('label.title');
            var dataSend;
            var dirPath;

            if (inputField.attr('id').indexOf('Student') >= 0)
            {
                dirPath = "Student/Student/";
            }
            else
            {
                var enteredBeginnningRange = skyward.controls.getValue($(parentDiv).find('input#editConfigDistrictGroup_StateAssignedAlternativeIDBeginningRange'));
                var enteredEndingRange = skyward.controls.getValue($(parentDiv).find('input#editConfigDistrictGroup_StateAssignedAlternativeIDEndingRange'));

                dirPath = "StateReporting/ConfigDistrict/";
                dataSend = $.param({ enteredBeginnningRange: enteredBeginnningRange, enteredEndingRange: enteredEndingRange });
            }

            $.ajax({
                url: skyward.global.virtualDir + dirPath + "GenerateNewStateAssignedAlternativeID",
                type: "POST",
                dataType: "JSON",
                data: dataSend,
                contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
                success: async function (data) {
                    if (data.success)
                    {
                        skyward.controls.setValue(inputField, data.update[0]);

                        // Clear error
                        helpLabel.html("");
                        titleLabel.removeClass("error-text");
                        inputField.removeClass("error-control");
                    }
                    else
                    {
                        skyward.controls.setValue(inputField, "");

                        // Show error
                        var iconSpan = $('<span/>');
                        var errorList = $("<ul/>");
                        $.when(skyward.svg.getSvg('Error', 'Error')).done(function (svg) {
                            iconSpan.append(svg);
                        });
                        var listItem = $("<li class='error-list'/>");
                        const processedError = await skyward.global.processViewPartHtml(data.errors['StateAssignedAlternativeID'][0]);
                        let html = processedError;
                        if (typeof processedError !== 'string')
                        {
                            html = processedError.toOuterHtmlString();
                        }
                        var errorMessage = $('<span>' + html + '</span>');
                        listItem.append(iconSpan);
                        listItem.append(errorMessage);
                        errorList.append(listItem);

                        helpLabel.html(errorList);
                        titleLabel.addClass("error-text");
                        inputField.addClass("error-control");
                    }
                }
            });
        };
    }(window.skyward = window.skyward || {}, window.jQuery)
);